import { useEffect, useState } from "react";
import { BellRing, X } from "lucide-react";
import { toast } from "sonner";
import { pushState, enablePush, disablePush, isIOS, isStandalone } from "@/lib/push";

export const PushToggle = ({ banner = false }) => {
  const [state, setState] = useState(null);
  const [busy, setBusy] = useState(false);
  const [hidden, setHidden] = useState(banner && localStorage.getItem("gogoats_push_dismissed") === "1");
  useEffect(() => { pushState().then(setState); }, []);

  const iosNeedsInstall = isIOS() && !isStandalone();
  if (state === null || hidden) return null;
  if (banner && (state !== "off" || iosNeedsInstall)) return null;

  const toggle = async () => {
    setBusy(true);
    try {
      if (state === "on") { await disablePush(); setState("off"); toast.success("Notifications désactivées"); }
      else { await enablePush(); setState("on"); toast.success("Notifications activées !"); }
    } catch {
      setState(await pushState());
      toast.error("Impossible d'activer les notifications. Vérifiez l'autorisation dans les réglages du navigateur.");
    }
    setBusy(false);
  };

  const text = state === "unsupported" ? (iosNeedsInstall ? "Sur iPhone : installez d'abord Gogoats (Partager → Sur l'écran d'accueil), puis ouvrez l'app pour activer les notifications." : "Ce navigateur ne gère pas les notifications.")
    : state === "denied" ? "Notifications bloquées : autorisez-les dans les réglages du navigateur."
    : state === "on" ? "Vous recevrez les alertes : inscriptions, capitaine, équipes, match ce soir…" : "Recevez une alerte à l'ouverture des inscriptions, quand une place se libère, le soir du match…";

  return (
    <div data-testid={banner ? "push-banner" : "push-toggle"} className="relative rounded-3xl p-4 flex items-center gap-3 bg-gradient-to-br from-violet-500 to-fuchsia-500 text-white shadow-lg shadow-fuchsia-500/20">
      <div className="w-11 h-11 rounded-2xl bg-white/20 flex items-center justify-center shrink-0"><BellRing className="w-5 h-5" /></div>
      <div className="flex-1 min-w-0">
        <p className="font-display font-bold text-sm">Notifications sur téléphone</p>
        <p className="text-xs text-white/85 leading-snug mt-0.5" data-testid="push-status-text">{text}</p>
      </div>
      {(state === "on" || state === "off") && (
        <button data-testid="push-toggle-button" disabled={busy} onClick={toggle} className={`shrink-0 rounded-full px-3.5 py-2 text-xs font-bold active:scale-95 transition ${state === "on" ? "bg-white/20" : "bg-white text-fuchsia-600"}`}>
          {busy ? "…" : state === "on" ? "Désactiver" : "Activer"}
        </button>
      )}
      {banner && (
        <button data-testid="push-banner-dismiss" onClick={() => { localStorage.setItem("gogoats_push_dismissed", "1"); setHidden(true); }} className="absolute top-1.5 right-1.5 p-1 text-white/70"><X className="w-4 h-4" /></button>
      )}
    </div>
  );
};
